module.exports = __webpack_public_path__ + "img/img5.58f77306.jpg";